class DataLayerPush {
  /**
   * dataLayerPush
   *
   * Pushes data to the GTM dataLayer
   *
   * @param  string   Name of the dataLayer event
   * @param  object   Data to push
   */
  async dataLayerPush (name, data) {
    let dataObj
    if (data instanceof Promise) {
      dataObj = await data || {}
    } else {
      dataObj = data || {}
    }

    dataObj.event = name

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(dataObj)
    return Promise.resolve(true)
  }
}

export default new DataLayerPush()
